import React, { useState } from "react";
import { Copy, Check } from "lucide-react";

export default function CopyableCode({ code, label, className = "" }) {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(code).catch(() => {});
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div
      data-testid="copyable-code-block"
      className={`flex items-center gap-3 bg-[#111111] border border-[#262626] rounded-lg px-4 py-3 group ${className}`}
    >
      {label && (
        <span className="text-xs font-mono text-[#3f3f46] select-none shrink-0">{label}</span>
      )}
      <code className="flex-1 text-sm font-mono text-[#ededed] truncate">{code}</code>
      <button
        data-testid="copy-code-btn"
        onClick={handleCopy}
        title="Copy to clipboard"
        className="shrink-0 text-[#3f3f46] hover:text-[#ededed] transition-colors"
      >
        {copied ? (
          <Check size={14} strokeWidth={2} className="text-[#10b981]" />
        ) : (
          <Copy size={14} strokeWidth={1.5} />
        )}
      </button>
    </div>
  );
}
